export const DATE_CONSTANTS = {
   TIME_FORMAT: 'HH:mm',
};
